// Import react libs
import { QueryClient } from '@tanstack/react-query';
import { persistQueryClient } from '@tanstack/react-query-persist-client';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';

// Timeout for the react query
const QUERY_TIMEOUT = Number(process.env.REACT_APP_QUERY_CLIENT_STALE_TIMEOUT);
const QUERY_CLEAR_CACHE_TIMEOUT = Number(
    process.env.REACT_APP_QUERY_CLIENT_CACHE_TIMEOUT,
);

// Timeout for the react query in the session storage
const QUERY_SESSION_STORAGE_TIMEOUT = Number(
    process.env.REACT_APP_QUERY_CLIENT_SESSION_STORAGE_TIMEOUT,
);

// Create react query client
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            // Refetch at windows focus
            refetchOnWindowFocus: true,

            // Refetch at reconnect (ex: connection to internet)
            refetchOnReconnect: true,

            // Refetch at mount time
            refetchOnMount: true,

            // Refetch automatically at regular intervals
            refetchInterval: false,

            // Keeps datas in cache for ...
            cacheTime: QUERY_CLEAR_CACHE_TIMEOUT,

            // Use actuals datas for ... before a refetch
            staleTime: QUERY_TIMEOUT,
        },
    },
});

// Create a persister for the query client
const sessionStoragePersister = createSyncStoragePersister({
    storage: window.sessionStorage,
});

// Persist the query client in the session storage
persistQueryClient({
    queryClient,
    persister: sessionStoragePersister,
    maxAge: QUERY_SESSION_STORAGE_TIMEOUT,
});

export default queryClient;
